import useAuth from '../../../../hooks/auth-hooks';
import { ICardGroupInsertUpdate } from '../../../../models/cardgroup.interface';

/**
 * Displays a widget on the customer form page the shows a list
 * of card groups associated with the customer.
 * 
 * @param {ICardGroupInsertUpdate} data the customer data
 * 
 * @returns void
 */
const DisplayCGFound = (data: ICardGroupInsertUpdate[]) => { 
  const { accessType } = useAuth()!;

  const container = document.querySelector('.aafp_side-form-container') as HTMLElement;

  const containerDiv = document.createElement('div');
  containerDiv.className = 'aafp_terminal-card aafp_border-radius';

  const headerEle = document.createElement('h3');
  headerEle.textContent = 'Card Group';

  const bodyContainer = document.createElement('div');
  bodyContainer.className = 'aafp_terminal-card-group mt-3';

  const cardBody = document.createElement('div');
  cardBody.className = 'aafp_terminal-card-group-body';

  const cardList = document.createElement('div');
  cardList.className = 'aafp_terminal-tax-list';

  data.forEach(({ cardGroupId, cardGroupName }) => {
    const cardGroupList = document.createElement('div');
    cardGroupList.className = 'terminal-tax-list aafp_color-theme-mid';

    const bodyContent = document.createElement('span');
    bodyContent.textContent = cardGroupName;

    const buttonContainer = document.createElement('div');
    
    const link = accessType === 'R' ? 'view' : 'edit'; 
    //console.log(accessType, link);
    const editButton = document.createElement('a');
    editButton.className = 'aafp_btn-table btn_theme-primary';
    editButton.href = `/card-group/${link}-card-group/?groupAction=${link}&groupID=${cardGroupId}`;
    editButton.setAttribute('data-toggle', 'tooltip');
    editButton.setAttribute('data-placement', 'bottom');
    editButton.title = `${link} ${cardGroupName}`;

    const editButtonIcon = document.createElement('i');
    editButtonIcon.className = link === 'edit' ? 'fas fa-pen' : 'far fa-eye';

    // let unLinkButton = document.createElement('a');
    // unLinkButton.className = 'aafp_btn-table';
    // unLinkButton.href = `/new-card-group/?groupAction=Add&groupID=${cardGroupId}`;
    // unLinkButton.setAttribute('data-toggle', 'tooltip');
    // unLinkButton.setAttribute('data-placement', 'bottom');
    // unLinkButton.title = `Unlink ${cardGroupName}`;

    // let unLinkButtonIcon = document.createElement('i');
    // unLinkButtonIcon.className = 'fas fa-unlink';

    cardList.appendChild(cardGroupList);
    cardGroupList.appendChild(bodyContent);
    cardGroupList.appendChild(buttonContainer);
    buttonContainer.appendChild(editButton);
    editButton.appendChild(editButtonIcon);
    //buttonContainer.appendChild(unLinkButton);
    //unLinkButton.appendChild(unLinkButtonIcon);
  });

  containerDiv.appendChild(headerEle);
  containerDiv.appendChild(bodyContainer);
  bodyContainer.appendChild(cardBody);
  cardBody.appendChild(cardList);
  container.appendChild(containerDiv);
}

export default DisplayCGFound;